import { Expose } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class ProductActionQuoteAttachment extends Entity<ProductActionQuoteAttachment> {
    @Expose()
    id!: string
    @Expose()
    label?: string
}
